"use client"

import { useEffect } from "react"
import posthog from "posthog-js"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Capture the error with PostHog
    if (typeof window !== "undefined" && window.posthog) {
      window.posthog.captureException(error, {
        digest: error.digest,
        global: true,
      })
    } else {
      // Fallback if window.posthog is not available yet
      posthog.captureException(error, {
        digest: error.digest,
        global: true,
      })
    }
  }, [error])

  return (
    <html>
      <body className="bg-[#FFFDF5]">
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center px-4">
            <h2 className="text-2xl font-bold text-[#591400] mb-4">
              Something went wrong
            </h2>
            <p className="text-[#591400] mb-6">
              We've been notified and are looking into it.
            </p>
            <button
              onClick={() => reset()}
              className="bg-[#591400] text-[#FFFDF5] px-6 py-2 rounded hover:bg-[#7a1d00] transition-colors"
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
